enum FeedbackStatus {
    Awaiting = 0,
    Delivered = 10,
    Opened = 11,
    Unsubscribed = 12,
    Error = 99
}

export default FeedbackStatus;